import loadingSlice from '@gagovictor/shared-frontend-core/dist/shared/redux/loadingSlice';
import { combineSlices, configureStore } from '@reduxjs/toolkit';

import tarotSlice, { saveTarotState, TarotState } from './tarot/tarotSlice';

// No auth, account or purchase slices: this app has no accounts and no server.
export const rootReducer = combineSlices(loadingSlice, tarotSlice);

export type RootState = {
    loading: ReturnType<typeof loadingSlice.reducer>;
    tarot: TarotState;
};

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        preloadedState: preloadedState as never,
    });
}

export type AppDispatch = typeof store.dispatch;

const store = setupStore();

let lastSaved: TarotState | undefined;
store.subscribe(() => {
    const next = store.getState().tarot;
    if (next !== lastSaved) {
        lastSaved = next;
        saveTarotState(next);
    }
});

export default store;
